__turbopack_context__.v({
  "image": "swiper-el-module-scss-module__xb57_W__image",
});
